import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { grammarRulesData, getDataForDifficulty } from '../courses/data/grammar/grammarRules';

export default function GrammarRulesTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : grammarRulesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
